export default __webpack_public_path__ + "static/media/cryptologo.339b7c1c.png";